export default __webpack_public_path__ + "static/media/deafness.bc1caee9.png";